import * as React from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { ApiClient } from "../../../lib/api";
import { MainComponentContainer } from "../../../shared/MainComponentContainer";
import { PagedList } from "../../../shared/PagedList";
import { RootState } from "../../../store/rootReducer";
import { InvoiceCell } from "./InvoiceCell";
import { Invoice } from "../../../lib/model/Invoice";
import { StyledTabs } from "../../../shared/ForwardTabs";
import { Tabs } from "antd";
import { InvoicesFilter } from "../../../lib/model/InvoicesFilter";
import { ListItem } from "../../../lib/model/ListItem";
import styled from "styled-components";
import { relativeLongMonthDate } from "../../../lib/formatters";

const client = new ApiClient();

const Wrapper = styled.div`
  padding: 30px;

  @media only screen and (max-width: 575px) {
    padding: 10px;
  }
`;

const SectionHeaderLabel = styled.span`
  font-size: 14px;
  display: inline-block;
  line-height: 1.21;
  color: #061a32;
  margin: 24px 0;
`;

const sectionIdentifierForInvoice = (invoice: Invoice): string => {
  return relativeLongMonthDate(invoice.createdAt);
};

const mapStateToProps = (state: RootState) => ({});

const dispatchProps = {
  push
};

type Props = ReturnType<typeof mapStateToProps> & typeof dispatchProps;

class InvoicesContainer extends React.Component<Props> {
  render = () => {
    return (
      <MainComponentContainer additionalMarginTop={38}>
        <StyledTabs type="card">
          <Tabs.TabPane tab="Offen" key="1">
            <Wrapper>
              <PagedList
                loadData={after =>
                  client.fetchInvoices(InvoicesFilter.Open, after)
                }
                renderItem={this.renderItem}
                getSectionIdentifier={sectionIdentifierForInvoice}
              />
            </Wrapper>
          </Tabs.TabPane>
          <Tabs.TabPane tab="Bezahlt" key="2">
            <Wrapper>
              <PagedList
                loadData={after =>
                  client.fetchInvoices(InvoicesFilter.Paid, after)
                }
                renderItem={this.renderItem}
                getSectionIdentifier={sectionIdentifierForInvoice}
              />
            </Wrapper>
          </Tabs.TabPane>
        </StyledTabs>
      </MainComponentContainer>
    );
  };
  renderItem = (item: ListItem<Invoice>): React.ReactElement => {
    if (!!item.sectionHeader) {
      return <SectionHeaderLabel>{item.sectionHeader}</SectionHeaderLabel>;
    }
    return (
      <InvoiceCell
        isPlaceholder={item.isPlaceholder}
        invoice={item.item}
        onDetailsClick={this.handleOrderDetailsClick}
      />
    );
  };
  handleOrderDetailsClick = (invoice: Invoice) => {
    this.props.push(`/invoices/${invoice.id}`);
  };
}

export default connect(
  mapStateToProps,
  dispatchProps
)(InvoicesContainer);
